import React from 'react';
import { useAdminStore } from '../../stores/useAdminStore';
import { useAdminVisible } from '../../hooks/useAdminVisible';
import './AddSeasonButton.css';

export const AddSeasonButton: React.FC = () => {
  const openSeasonCreateModal = useAdminStore(s => s.openSeasonCreateModal);
  const isVisible = useAdminVisible();

  if (!isVisible) {
    return null;
  }

  return (
    <div className="add-season-button-container">
      <button
        onClick={openSeasonCreateModal}
        className="add-season-button"
        aria-label="Create new season"
        data-testid="add-season-button"
      >
        <div className="add-season-icon">
          <div className="add-season-button__icon">+</div>
          <div className="add-season-button__label">Add Season</div>
        </div>
      </button>
    </div>
  );
};
